import { t } from 'i18n';
import React, { useCallback, useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
import { Dropdown, DropdownMenu, DropdownToggle } from '@teko/ui';
import { CartNumberTracking } from '@teko/ecommerce';
import get from 'lodash.get';
import { useCart } from 'contexts';
import { getScrollbarWidth } from 'helpers';
import { styled, CustomLink, Badge, Body } from '@teko/ds-desktop';
import { ShoppingCartOutlined } from '@teko/ds-icon';
import { getTrackingData } from '@teko/teko-ecommerce';
import { NavigationButton } from './style';
const MiniCart = dynamic(() =>
  import('components/MiniCart').then((mod) => mod.MiniCart),
);
interface CartOverviewProps {
  vertical?: boolean;
  showShippingFeeMiniCart?: boolean;
}
const StyledDropdown = styled(Dropdown)`
  width: auto;
`;
const WrapperBadge = styled.div`
  position: absolute;
  top: 5px;
  left: calc(50% + 15px);
`;
export const CartOverview: React.FC<CartOverviewProps> = ({
  vertical = false,
  showShippingFeeMiniCart = true,
}: CartOverviewProps) => {
  const cart = useCart();
  const [miniCartOpen, setMiniCartOpen] = useState(false);
  const toggleMiniCart = useCallback(() => {
    setMiniCartOpen(!miniCartOpen);
  }, [miniCartOpen]);
  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (miniCartOpen) {
        document.body.style.overflow = 'hidden';
        document.body.style.paddingRight = `${getScrollbarWidth()}px`;
      } else {
        document.body.style.overflow = 'unset';
        document.body.style.paddingRight = 'unset';
      }
    }
  }, [miniCartOpen]);
  return (
    <StyledDropdown
      isOpen={miniCartOpen}
      toggle={toggleMiniCart}
      toggleType="hover"
      onHide={(): void => setMiniCartOpen(false)}
      {...getTrackingData({
        isTrackContent: true,
        regionName: 'headerBar',
        contentName: 'cartItem',
        target: 'shoppingCart',
      })}
    >
      <DropdownToggle>
        <CustomLink href="/cart">
          {vertical ? (
            <NavigationButton
              className="button"
              style={{ flexDirection: 'column' }}
            >
              <ShoppingCartOutlined size={36} color="textSecondary" />
              <Body
                level={2}
                weight="medium"
                color="textSecondary"
                className="title"
              >
                {t('Giỏ hàng')}
              </Body>
              {cart.totalCartItemsSelected > 0 && (
                <WrapperBadge>
                  <Badge count={cart.totalCartItemsSelected} />
                </WrapperBadge>
              )}
            </NavigationButton>
          ) : (
            <NavigationButton>
              <ShoppingCartOutlined size={36} color="textSecondary" />
              <div className="text-left ml-6">
                <Body
                  level={2}
                  weight="medium"
                  color="textSecondary"
                  className="title"
                >
                  {t('Giỏ hàng của bạn')}
                </Body>
                <Body
                  level={2}
                  weight="medium"
                  color="textSecondary"
                  className="title"
                >
                  {t('({{cartTotalCartItems}}) sản phẩm', {
                    cartTotalCartItems: cart.totalCartItemsSelected,
                  })}
                </Body>
              </div>
            </NavigationButton>
          )}
        </CustomLink>

        <CartNumberTracking totalItems={cart.totalCartItemsSelected} />
      </DropdownToggle>
      <DropdownMenu popperConfig={{ placement: 'top-end' }}>
        <MiniCart
          onHide={(): void => setMiniCartOpen(false)}
          disableProductPromo={get(cart, 'order.disableProductPromo', false)}
          showShippingFee={showShippingFeeMiniCart}
        />
      </DropdownMenu>
    </StyledDropdown>
  );
};
